import { useLayoutEffect, useState } from "react";
import {
  EditButton,
  Link,
  Show,
  TabbedShowLayout,
  TabbedShowLayoutTabs,
  TopToolbar,
  useRecordContext,
  usePermissions,
  Button,
} from "react-admin";
import { isOhbatRazaEvent } from "@/utils/raza-event-display";
import { hasPermission } from "@/utils/permission-utils";
import { MakhsoosHostSectorTab } from "./MakhsoosHostSectorTab";
import { RazaEventOhbatAttendanceTab } from "./RazaEventOhbatAttendanceTab";
import { RazaEventsDetailsTab } from "./RazaEventsDetailsTab";
import { ChangeSadaratDialog } from "@/components/raza/ChangeSadaratDialog";
import {
  ChangeKhidmatDialog,
  ChangeZakereenDialog,
} from "./components/RazaEventPartialEditDialogs";
import {
  registerRazaEventsShowDialogOpeners,
  unregisterRazaEventsShowDialogOpeners,
} from "./raza-events-show-dialog-openers";

function RazaEventsShowActions() {
  const record = useRecordContext();

  const { permissions } = usePermissions();
  const [sadaratOpen, setSadaratOpen] = useState(false);
  const [khidmatOpen, setKhidmatOpen] = useState(false);
  const [zakereenOpen, setZakereenOpen] = useState(false);

  const canEditMajlis = hasPermission(permissions, "razaEvents.edit");
  const isOhbat = record ? isOhbatRazaEvent(record) : false;
  const razaRequestId = record?.razaRequestId;

  const id = record?.id;

  useLayoutEffect(() => {
    if (!isOhbat) {
      unregisterRazaEventsShowDialogOpeners();
      return undefined;
    }
    registerRazaEventsShowDialogOpeners({
      openSadarat: () => setSadaratOpen(true),
      openKhidmat: () => setKhidmatOpen(true),
      openZakereen: () => setZakereenOpen(true),
    });
    return () => unregisterRazaEventsShowDialogOpeners();
  }, [isOhbat]);

  return (
    <>
      <TopToolbar>
        {canEditMajlis ? <EditButton /> : null}
        {!isOhbat && razaRequestId != null ? (
          <Button
            component={Link}
            to={`/razaRequests/${String(razaRequestId)}/show`}
            label="View raza request"
          />
        ) : null}
      </TopToolbar>
      {id != null && isOhbat && (
        <>
          <ChangeSadaratDialog
            open={sadaratOpen}
            onClose={() => setSadaratOpen(false)}
            majlisId={id}
          />
          <ChangeKhidmatDialog
            open={khidmatOpen}
            onClose={() => setKhidmatOpen(false)}
            majlisId={id}
          />
          <ChangeZakereenDialog
            open={zakereenOpen}
            onClose={() => setZakereenOpen(false)}
            majlisId={id}
          />
        </>
      )}
    </>
  );
}

function RazaEventsShowLayout() {
  const record = useRecordContext();
  const isOhbat = record ? isOhbatRazaEvent(record) : true;

  return (
    <TabbedShowLayout
      tabs={
        <TabbedShowLayoutTabs
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 48,
            "& .MuiTabs-scrollButtons.Mui-disabled": { opacity: 0.3 },
          }}
        />
      }
    >
      <TabbedShowLayout.Tab label="Details">
        <RazaEventsDetailsTab />
      </TabbedShowLayout.Tab>
      {isOhbat ? (
        <>
          <TabbedShowLayout.Tab label="Makhsoos (host sector / sub-sector)" path="makhsoos">
            <MakhsoosHostSectorTab />
          </TabbedShowLayout.Tab>
          <TabbedShowLayout.Tab label="Attendance" path="attendance">
            <RazaEventOhbatAttendanceTab />
          </TabbedShowLayout.Tab>
        </>
      ) : null}
    </TabbedShowLayout>
  );
}

const RazaEventsShow = () => (
  <>
    <Show actions={<RazaEventsShowActions />}>
      <RazaEventsShowLayout />
    </Show>
  </>
);

export default RazaEventsShow;
